<template lang="pug">
.wagtail-vacancy-promo
  img(:src="value.image ? $getImgUrl.origin(value.image.download_path): ''").wagtail-vacancy-promo__avatar
  nuxt-link(:to="`/vacancy/${value.vacancy_page.slug}`")
    h3.wagtail-vacancy-promo__title {{ value.title }}
  .wagtail-vacancy-promo__subtitle(v-html="value.paragraph")
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.wagtail-vacancy-promo {
  margin-bottom: 85px;

  &__avatar {
    width: 58px;
    height: 58px;
    margin-bottom: 23px;
  }

  &__title {
    margin-bottom: 23px;
    color: $dark;
    text-transform: uppercase;
  }

  &__subtitle {
    color: $dark;
  }
}
</style>

